import type { Feature } from '@ben/orion/manage-benefit-features';
import ManageBenefitFeaturesOrion from '@ben/orion/manage-benefit-features';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useFeaturesGenerate } from './use-features-generate';

interface ManageBenefitFeaturesProps {
  features: Feature[];
  onChange: (features: Feature[]) => void;
  benefitId?: string;
  showRankField?: boolean;
}

const ManageBenefitFeatures = ({
  onChange,
  features,
  benefitId,
  showRankField,
}: ManageBenefitFeaturesProps) => {
  const { t } = useTranslation();
  const {
    refetch: refetchGenerateFeatures,
    isFetching: isFetchingGenerateFeatures,
  } = useFeaturesGenerate({ benefitId });

  const handleGenerateWithAi = useCallback(async () => {
    const result = await refetchGenerateFeatures();
    if (result.isError) {
      toast.error(
        t('manageBenefitFeatures.generateWithAiError', {
          defaultValue: 'Error generating features',
        })
      );
      return;
    }

    toast.info(t('manageBenefitFeatures.generationStarted'));
  }, [refetchGenerateFeatures, t]);

  const handleGenerateWithAiSync = useCallback(() => {
    void handleGenerateWithAi().catch(console.error);
  }, [handleGenerateWithAi]);

  return (
    <ManageBenefitFeaturesOrion
      features={features}
      onGenerateWithAi={benefitId ? handleGenerateWithAiSync : undefined}
      isLoadingGenerateWithAi={isFetchingGenerateFeatures}
      onChange={onChange}
      showRankField={showRankField}
    />
  );
};

export default ManageBenefitFeatures;
